<template>
  <div>
    <v-card :loading="isLoading" class="mb-3">
      <v-card-title>
        <h3 class="card-label">
          <div v-if="originalData?.customer">
            <small>Müşteri Faturası</small><br />
            <span>{{ originalData.customer.name }}</span>
            <span
              ><rs-table-cell-date :value="originalData.invoiced_on"
            /></span>
            <div class="mt-2" v-if="id">
              <v-chip x-small label color="primary">
                {{ getInvoiceTypeText() }}
              </v-chip>
            </div>
          </div>
          <span v-else>Müşteriye Fatura Ekle</span>
        </h3>
        <v-col class="text-right p-0">
          <!-- <rs-action
            @click="showActionLogs"
            v-if="id"
            icon
            title="Düzenleme geçmişi"
          >
            <v-icon>mdi-information-variant</v-icon>
          </rs-action> -->
          <rs-action
            :href="
              'https://uygulama.parasut.com/416690/satislar/' +
              originalData.accounting_id
            "
            target="_blank"
            v-if="
              id &&
              originalData.accounting_id &&
              !originalData.reversal_verified_at
            "
            icon
            title="Paraşüt'te göster"
          >
            P
          </rs-action>
          <rs-action
            @confirmed="handleSyncClick"
            target="_blank"
            v-if="
              id &&
              !originalData.accounting_id &&
              !originalData.reversal_verified_at
            "
            icon
            tooltip="Paraşüt'e gönder"
            confirmed
            :is-loading="isLoading"
          >
            <v-icon>mdi-file-sync-outline</v-icon>
          </rs-action>
          <rs-action
            @confirmed="handleRegisterClick"
            target="_blank"
            v-if="
              id &&
              !originalData.reversal_verified_at &&
              originalData.accounting_id &&
              originalData.accounting_registered_at === null &&
              ((originalData.accounting_e_invoice_id === null &&
                originalData.accounting_e_archive_id === null) ||
                originalData.accounting_registration_status === 'error' ||
                originalData.accounting_registration_status === 'failed')
            "
            icon
            tooltip="Resmileştir"
            confirmed
            :is-loading="isLoading"
          >
            <v-icon>mdi-file-certificate-outline</v-icon>
          </rs-action>
          <rs-action
            target="_blank"
            @click="handleRegisterCheckClick"
            v-if="
              id &&
              !originalData.reversal_verified_at &&
              originalData.accounting_id &&
              (originalData.accounting_e_invoice_id !== null ||
                originalData.accounting_e_archive_id !== null) &&
              (originalData.accounting_registered_at === null ||
                !originalData.document_id)
            "
            icon
            tooltip="Resmileştirme kontrol"
            :is-loading="isLoading"
          >
            <v-icon>mdi-invoice-clock-outline</v-icon>
          </rs-action>
          <rs-action
            @click="showReversalPanel"
            v-if="
              id &&
              originalData.accounting_registered_at &&
              originalData.document_id &&
              !originalData.reversal_verified_at
            "
            icon
            tooltip="İptal Yönetimi"
            :is-loading="isLoading"
          >
            <v-icon>mdi-file-rotate-left-outline</v-icon>
          </rs-action>
          <rs-action-delete
            target="_blank"
            confirmed
            @click="handleDeleteClick"
            v-if="
              id &&
              ((originalData.accounting_registered_at === null &&
                originalData.accounting_e_invoice_id === null &&
                originalData.accounting_e_archive_id === null) ||
                !!originalData.reversal_verified_at)
            "
            icon
            tooltip="Sil"
            :is-loading="isLoading"
          />
        </v-col>
        <!-- <div class="d-block w-100 mb-2">
          <rs-return-to />
        </div> -->
      </v-card-title>
      <v-card-text>
        <v-form
          :readonly="disabled"
          @submit.prevent.stop="handleFormSubmit"
          ref="form"
          :disabled="isLoading || disabled"
        >
          <v-row dense>
            <v-col cols="12">
              <div class="text-subtitle-2 font-weight-medium">
                Fatura Bilgileri
              </div>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="6">
              <rs-select-customer
                v-model="formData.customer_id"
                :rules="[rules.required]"
                @change:item="handleProductSelected"
                :readonly="id"
                required
              />
            </v-col>

            <v-col cols="12" sm="6">
              <rs-datepicker
                label="Fatura Tarihi"
                v-model="formData.invoiced_on"
                :rules="[rules.required]"
              />
            </v-col>

            <v-col cols="12" sm="6">
              <rs-money-field
                label="Toplam Tutar"
                v-model="formData.amount"
                disabled
              />
            </v-col>

            <v-col cols="12" sm="6">
              <rs-money-field
                label="Toplam Tutar KDV Dahil"
                v-model="formData.amount_tax_included"
                disabled
              />
            </v-col>
          </v-row>

          <v-row dense v-if="id">
            <v-col cols="12">
              <div class="text-subtitle-2 font-weight-medium mt-2">
                Entegrasyon Bilgileri
              </div>
            </v-col>

            <v-col cols="12" sm="6">
              <rs-text-field
                label="Fatura Durumu"
                :value="getInvoiceWorkflowStatus()"
                disabled
              />
            </v-col>

            <v-col cols="12" sm="6">
              <rs-text-field
                label="Muhasebe Entegrasyon ID"
                v-model="formData.accounting_id"
                disabled
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              v-if="hasDisplayableDate(originalData.accounting_registered_at)"
            >
              <rs-text-field
                label="Resmileştirme Tarihi"
                :value="formatDateTime(originalData.accounting_registered_at)"
                disabled
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              v-if="hasDisplayableDate(originalData.reversal_verified_at)"
            >
              <rs-text-field
                label="İptal Tarihi"
                :value="formatDateTime(originalData.reversal_verified_at)"
                disabled
              />
            </v-col>

            <v-col cols="12" v-if="originalData.accounting_registration_error">
              <rs-textarea
                label="Resmileştirme Hatası"
                :value="originalData.accounting_registration_error"
                disabled
                auto-grow
                rows="2"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col sm="8">
              <h3 class="mt-8">Kalemler</h3>
            </v-col>
            <v-col sm="4" class="text-end align-content-end">
              <v-btn
                class="mb-2"
                icon
                small
                outlined
                color="pink"
                @click.prevent="handleAddItemClick"
                title="Kalem ekle"
                :disabled="formData.is_auto_invoiced || !formData.customer_id"
                v-if="!id || !originalData.accounting_id"
              >
                +
              </v-btn>
            </v-col>
          </v-row>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="bg-secondary bordered">
                  <th>TYA</th>
                  <th>Dönem</th>
                  <th>Gün</th>
                  <th>BB</th>
                  <th>Birim</th>
                  <th>Tutar</th>
                  <th>KDV</th>
                  <th>Toplam</th>
                  <th></th>
                </tr>
              </thead>
              <tfoot v-if="formData.items.length">
                <tr class="bg-secondary bordered">
                  <td>Toplamlar</td>
                  <td></td>
                  <td></td>
                  <td class="text-end">{{ itemTotals.units }}</td>
                  <td></td>
                  <td class="text-end">
                    <rs-table-cell-number
                      price
                      :value="itemTotals.total_amount"
                    />
                  </td>
                  <td class="text-end">
                    <rs-table-cell-number
                      price
                      :value="itemTotals.tax_amount"
                    />
                  </td>
                  <td class="text-end">
                    <rs-table-cell-number price :value="itemTotals.sum" />
                  </td>
                  <td></td>
                </tr>
              </tfoot>
              <tbody>
                <tr
                  class="bordered"
                  v-for="item in formData.items"
                  :key="item.id || item.key"
                >
                  <template v-if="item.editing">
                    <td>
                      <rs-select-cluster
                        label="TYA Seçin"
                        v-model="item.cluster_id"
                        :rules="[rules.required]"
                        :clearable="false"
                        :search-params="{ customer_id: formData.customer_id }"
                        use-customer-relation
                        :customer-relation-date="formData.invoiced_on"
                        @change:item="handleClusterSelect($event, item)"
                      />
                    </td>
                    <td>-</td>
                    <td>
                      <rs-text-field
                        type="number"
                        min="1"
                        step="1"
                        v-model="item.invoiced_days"
                        :rules="[rules.required]"
                        :suffix="formData.is_yearly ? '/ 365' : '/ 30'"
                        @change="recalculateItem(item)"
                      />
                    </td>
                    <td class="text-end">
                      <rs-text-field
                        type="number"
                        min="1"
                        step="1"
                        v-model="item.units"
                        :rules="[rules.required]"
                        suffix="BB"
                        @change="recalculateItem(item)"
                      />
                    </td>
                    <td class="text-end money-absolute-left">
                      <rs-money-field
                        type="number"
                        min="0"
                        step="0.01"
                        v-model="item.amount_per_unit"
                        :rules="[rules.required]"
                        @change="recalculateItem(item)"
                      />
                    </td>
                    <td class="text-end">
                      <rs-table-cell-number price :value="item.total_amount" />
                    </td>
                    <td class="text-end">
                      <rs-table-cell-number price :value="item.tax_amount" />
                    </td>
                    <td class="text-end">
                      <rs-table-cell-number
                        price
                        :value="item.total_amount + item.tax_amount"
                      />
                    </td>
                    <td class="text-center">
                      <v-btn
                        class="mb-2"
                        icon
                        small
                        outlined
                        color="pink"
                        @click.prevent="handleRemoveItemClick(item)"
                        title="Kaldır"
                        :disabled="formData.is_auto_invoiced"
                        v-if="!id || !originalData.accounting_id"
                      >
                        <i class="menu-icon mdi mdi-delete-outline"></i>
                      </v-btn>
                    </td>
                  </template>
                  <template v-else>
                    <td>
                      {{ item.customer_cluster.cluster.name }}
                    </td>
                    <td>
                      {{ formatItemPeriod(item) }}
                    </td>
                    <td class="text-end">
                      {{ item.invoiced_days }} /
                      <span v-if="formData.is_yearly">365</span
                      ><span v-else>30</span>
                    </td>
                    <td class="text-end">{{ item.units }}</td>
                    <td class="text-end">
                      <rs-table-cell-number
                        price
                        :value="item.amount_per_unit"
                      />
                    </td>
                    <td class="text-end">
                      <rs-table-cell-number price :value="item.total_amount" />
                    </td>
                    <td class="text-end">
                      <rs-table-cell-number price :value="item.tax_amount" />
                    </td>
                    <td class="text-end">
                      <rs-table-cell-number
                        price
                        :value="getItemGrossTotal(item)"
                      />
                    </td>
                    <td class="text-center">
                      <v-btn
                        class="mb-2"
                        icon
                        small
                        outlined
                        color="pink"
                        @click.prevent="item.editing = true"
                        title="Düzenle"
                        :disabled="formData.is_auto_invoiced"
                        v-if="!id || !originalData.accounting_id"
                      >
                        <i class="menu-icon mdi mdi-pencil"></i>
                      </v-btn>
                      <v-btn
                        class="mb-2 ml-1"
                        icon
                        small
                        outlined
                        color="pink"
                        @click.prevent="handleRemoveItemClick(item)"
                        title="Kaldır"
                        :disabled="formData.is_auto_invoiced"
                        v-if="!id || !originalData.accounting_id"
                      >
                        <i class="menu-icon mdi mdi-delete-outline"></i>
                      </v-btn>
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <rs-form-buttons
            :isLoading="isLoading"
            @cancel="handleCancelClick"
            @submit="handleFormSubmit"
            v-if="!disabled && (!id || !originalData.accounting_id)"
          />
        </v-form>
      </v-card-text>
    </v-card>

    <v-card :loading="isLoading">
      <v-card-title>Ödemeler</v-card-title>
      <v-card-text v-if="originalData.customer_id">
        <CustomerInvoicePaymentList
          ref="invoicePaymentList"
          :customer-id="originalData.customer_id"
          :invoice-id="id"
        />
      </v-card-text>
      <v-card-text v-else>
        Ödemeleri düzenlemek için faturayı kaydedin.
      </v-card-text>
    </v-card>

    <rs-side-panel
      ref="reversalPanel"
      v-if="
        id &&
        originalData.accounting_registered_at &&
        !originalData.reversal_verified_at
      "
    >
      <template slot="header"> İptal Yönetimi </template>
      <template slot="body">
        <v-row dense>
          <v-col cols="12">
            <rs-text-field
              label="İptal Çözüm Tarihi"
              :value="
                originalData.reversal_verified_at
                  ? new Date(originalData.reversal_verified_at).toLocaleString()
                  : 'Henüz çözülmedi'
              "
              disabled
            />
          </v-col>

          <template v-if="isReversalLoading">
            <v-col cols="12">
              <v-alert type="info" outlined dense>
                Paraşüt belge bilgileri yükleniyor.
              </v-alert>
            </v-col>
          </template>

          <template v-else-if="reversalContext">
            <v-col cols="12" sm="6">
              <rs-text-field
                label="Belge Kanalı"
                :value="
                  getDocumentChannelText(reversalContext.document.channel)
                "
                disabled
              />
            </v-col>
            <v-col cols="12" sm="6">
              <rs-text-field
                label="Belge Durumu"
                :value="
                  getProviderDocumentStatusText(reversalContext.document.status)
                "
                disabled
              />
            </v-col>
            <v-col cols="12" sm="6">
              <rs-text-field
                label="Belge Numarası"
                :value="reversalContext.document.number"
                disabled
              />
            </v-col>
            <v-col cols="12" sm="6">
              <rs-text-field
                label="Belge ID"
                :value="reversalContext.document.id"
                disabled
              />
            </v-col>
            <v-col cols="12" sm="6">
              <rs-text-field
                label="Paraşüt Fatura Tipi"
                :value="reversalContext.sales_invoice.item_type"
                disabled
              />
            </v-col>
            <v-col cols="12" sm="6">
              <rs-text-field
                label="Senaryo"
                :value="reversalContext.document.scenario || '-'"
                disabled
              />
            </v-col>
            <v-col
              cols="12"
              v-if="
                reversalContext.document.pdf_path ||
                reversalContext.document.html_path
              "
            >
              <v-btn
                v-if="reversalContext.document.pdf_path"
                small
                outlined
                color="primary"
                class="mr-2"
                :href="buildParasutAppUrl(reversalContext.document.pdf_path)"
                target="_blank"
              >
                PDF
              </v-btn>
              <v-btn
                v-if="reversalContext.document.html_path"
                small
                outlined
                color="primary"
                :href="buildParasutAppUrl(reversalContext.document.html_path)"
                target="_blank"
              >
                HTML
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-if="reversalContext.direct_cancel_detected"
                type="info"
                outlined
                dense
              >
                Bu fatura Paraşütte iptal edilmiş görünüyor. İptal
                Edebilirsiniz.
              </v-alert>
              <v-alert
                v-else-if="reversalContext.linked_reversal_document"
                type="info"
                outlined
                dense
              >
                Bu fatura Paraşüt'te iade edilmiş görünüyor. Bulunan iade
                belgesi ile doğrulanabilir.
                ID: {{ reversalContext.linked_reversal_document.id }}
              </v-alert>
              <v-alert v-else type="warning" outlined dense>
                Bu fatura Paraşüt'te doğrudan iptal edilebilir görünmüyor. İptal
                / iade fatura id girilerek doğrulanmalı.
              </v-alert>
            </v-col>
            <v-col cols="12" v-if="reversalContext.requires_reversal_document">
              <rs-text-field
                label="İptal / İade Fatura ID"
                v-model="reversalForm.reversal_document_id"
              />
            </v-col>
            <v-col cols="12">
              <rs-textarea
                label="Ek Not"
                v-model="reversalForm.reversal_note"
                auto-grow
                rows="4"
              />
            </v-col>
          </template>

          <v-col cols="12" v-else>
            <v-alert type="error" outlined dense>
              Paraşüt belge bilgileri alınamadı.
            </v-alert>
          </v-col>

          <v-col cols="12" class="text-right">
            <v-btn
              color="primary"
              :loading="isLoading"
              :disabled="isReversalLoading || !reversalContext"
              @click="handleVerifyReversalClick"
            >
              {{ getReversalActionLabel() }}
            </v-btn>
            <v-btn
              class="ml-2"
              outlined
              color="pink"
              :disabled="isLoading || isReversalLoading"
              @click="hideReversalPanel"
            >
              Kapat
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </rs-side-panel>
  </div>
</template>

<script>
import { hasDataTable, hasForm, isPage } from "@/view/mixins";
import { CustomerInvoicePaymentList } from "../components";
import { getInvoiceWorkflowStatusText } from "./invoiceWorkflow";

export default {
  name: "AdminCustomerInvoiceForm",
  mixins: [hasDataTable, hasForm, isPage],
  components: { CustomerInvoicePaymentList },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    id() {
      this.load();
    },
  },
  data() {
    const routeCustomerId = this.$route?.query?.customer_id
      ? Number(this.$route.query.customer_id)
      : null;

    return {
      selectedTab: "info",
      pageMeta: {
        title: "Müşteri Faturası",
      },
      formData: {
        customer_id: Number.isFinite(routeCustomerId) ? routeCustomerId : null,
        invoiced_on: new Date().toJSON().split("T")[0],
        amount: null,
        amount_tax_included: null,
        accounting_id: null,
        is_auto_invoiced: false,
        items: [],
        is_yearly: false,
      },
      itemTotals: {
        units: 0,
        total_amount: 0,
        tax_amount: 0,
        sum: 0,
      },
      isReversalLoading: false,
      reversalContext: null,
      reversalForm: {
        reversal_document_id: null,
        reversal_note: null,
      },
      nextLocalItemKey: 1,
    };
  },
  methods: {
    /**
     * Retrieves item data
     * @return {Promise} Resolves if data is retrieved
     */
    applyInvoiceDetails(data) {
      const formData = Object.assign({}, data);

      formData.items = (formData.items || [])
        .map((v) => {
          v.editing = false;
          return v;
        })
        .sort((a, b) => {
          const nameCompare = a.customer_cluster.cluster.name.localeCompare(
            b.customer_cluster.cluster.name
          );
          if (nameCompare !== 0) {
            return nameCompare;
          }
          return (a.period_starts_on || "").localeCompare(
            b.period_starts_on || ""
          );
        });

      this.formData = formData;
      this.originalData = Object.assign({}, formData);
      this.pageMeta.title =
        this.originalData.customer.name + " Fatura Düzenleme";
      this.refreshInvoiceTotals();
      this.reversalContext = null;
      this.reversalForm = {
        reversal_document_id: formData.reversal_document_id,
        reversal_note: formData.reversal_note,
      };
    },
    load() {
      this.isLoading = true;

      const scopes = [
        "customer",
        "items",
        "items.customerCluster",
        "items.customerCluster.cluster",
      ];
      const params = Object.assign(this.buildSearchParams({ scopes: scopes }));

      return this.$api
        .query(`api-super-admin/customer-invoices/${this.id}`, { params })
        .then((response) => {
          this.applyInvoiceDetails(response.data.data);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async reloadInvoiceDetails(delay = 150) {
      if (!this.id) {
        return;
      }

      if (delay > 0) {
        await new Promise((resolve) => setTimeout(resolve, delay));
      }

      await this.load();
    },
    handleFormSubmit(event) {
      if (this.isLoading || !this.$refs.form.validate()) {
        this.$toast.error("Lütfen tüm gerekli alanları doldurunuz");
        return false;
      }

      this.isLoading = true;
      const formData = Object.assign({}, this.formData);

      if (formData.phone) {
        formData.phone = this.formData.phone.replace(/[^0-9+]/g, "");
      }

      if (this.id) {
        this.$api
          .put(`api-super-admin/customer-invoices/${this.id}`, formData)
          .then(async (response) => {
            this.$toast.success("Kaydedildi");
            if (event && event.closeOnSave) {
              this.$router.back();
              return;
            }

            this.loadData(response);
            await this.reloadInvoiceDetails();
          })
          .catch((error) => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$api
          .post(`api-super-admin/customer-invoices`, formData)
          .then((response) => {
            this.$toast.success("Kaydedildi");
            if (event && event.closeOnSave) {
              this.$router.back();
              return;
            }

            this.$router.replace({
              name: "admin.crm.customer-invoices.edit",
              params: { id: response.data.data.id },
            });
          })
          .catch((error) => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    handleCancelClick() {
      this.$router.back();
    },
    async handleSyncClick() {
      if (!this.id || this.isLoading) {
        return false;
      }

      this.isLoading = true;

      try {
        await this.$api.post(
          `api-super-admin/customer-invoices/${this.id}/sync`
        );
        await this.reloadInvoiceDetails();
        this.$toast.success("Kaydedildi");
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handleRegisterClick() {
      if (!this.id || this.isLoading || !this.originalData.accounting_id) {
        return false;
      }

      this.isLoading = true;

      try {
        await this.$api.post(
          `api-super-admin/customer-invoices/${this.id}/register`
        );
        await this.reloadInvoiceDetails();
        this.$toast.success("Kaydedildi");
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handleRegisterCheckClick() {
      if (!this.id || this.isLoading || !this.originalData.accounting_id) {
        return false;
      }

      this.isLoading = true;

      try {
        await this.$api.get(
          `api-super-admin/customer-invoices/${this.id}/register-check`
        );
        await this.reloadInvoiceDetails(0);
        this.$toast.success("Resmileştirme başarılı");
      } catch (error) {
        await this.reloadInvoiceDetails();
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handleVerifyReversalClick() {
      if (
        !this.id ||
        this.isLoading ||
        this.isReversalLoading ||
        !this.reversalContext
      ) {
        return false;
      }

      this.isLoading = true;

      try {
        const response = await this.$api.post(
          `api-super-admin/customer-invoices/${this.id}/verify-reversal`,
          this.reversalForm
        );
        this.applyInvoiceDetails(response.data.data);
        this.hideReversalPanel();
        await this.reloadInvoiceDetails();
        this.$toast.success("İptal edildi");
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    showReversalPanel() {
      if (!this.$refs.reversalPanel) {
        return;
      }

      this.$refs.reversalPanel.show();
      this.loadCancellationContext();
    },
    hideReversalPanel() {
      if (!this.$refs.reversalPanel) {
        return;
      }

      this.$refs.reversalPanel.hide();
    },
    loadCancellationContext() {
      if (!this.id || this.isReversalLoading) {
        return false;
      }

      this.isReversalLoading = true;
      this.reversalContext = null;

      return this.$api
        .get(
          `api-super-admin/customer-invoices/${this.id}/cancellation-context`
        )
        .then((response) => {
          this.reversalContext = response.data.data;
          if (this.reversalContext.direct_cancel_detected) {
            this.reversalForm.reversal_document_id = null;
          } else if (this.reversalContext.linked_reversal_document?.id) {
            this.reversalForm.reversal_document_id =
              this.reversalContext.linked_reversal_document.id;
          } else {
            this.reversalForm.reversal_document_id = null;
          }
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isReversalLoading = false;
        });
    },
    getDocumentChannelText(value) {
      const map = {
        e_invoice: "e-Fatura",
        e_archive: "e-Arşiv",
      };

      return map[value] || value || "-";
    },
    getProviderDocumentStatusText(value) {
      const map = {
        successful: "Başarılı",
        legalized: "Resmileşti",
        sent: "Gönderildi",
      };

      return map[value] || value || "-";
    },
    formatDateTime(value) {
      if (!value) {
        return null;
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return date.toLocaleString("tr-TR");
    },
    hasDisplayableDate(value) {
      if (!value || typeof value !== "string") {
        return false;
      }

      return !Number.isNaN(new Date(value).getTime());
    },
    getInvoiceWorkflowStatus() {
      // Detail ekranında kullanıcıya teknik provider status yerine
      // faturanın son iş durumunu gösteriyoruz.
      return getInvoiceWorkflowStatusText(this.originalData);
    },
    getInvoiceTypeText() {
      return this.originalData.is_auto_invoiced
        ? "Otomatik Fatura"
        : "Manuel Fatura";
    },
    buildParasutAppUrl(path) {
      if (!path) {
        return null;
      }

      if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
      }

      return `https://uygulama.parasut.com${path}`;
    },
    getReversalActionLabel() {
      if (!this.reversalContext) {
        return "İptali Doğrula";
      }

      if (this.reversalContext.direct_cancel_detected) {
        return "İptal Et";
      }

      return "İptal / İade Faturasını Doğrula";
    },
    handleAddItemClick() {
      const newItem = {
        key: `new-${this.nextLocalItemKey++}`,
        editing: true,
        cluster_id: null,
        units: null,
        amount_per_unit: null,
        invoiced_days: null,
        total_amount: null,
        tax_amount: null,
      };

      this.formData.items.push(newItem);
    },
    handleRemoveItemClick(item) {
      const itemKey = item.id || item.key;
      this.formData.items = this.formData.items.filter(
        (currentItem) => (currentItem.id || currentItem.key) !== itemKey
      );
      this.refreshInvoiceTotals();
    },
    handleClusterSelect(event, item) {
      item.units = event.house_count;
    },
    recalculateItem(item) {
      if (
        item.units > 0 &&
        item.invoiced_days > 0 &&
        item.amount_per_unit > -0.01
      ) {
        const divider = this.formData.is_yearly ? 365 : 30;
        item.total_amount =
          (item.units * item.invoiced_days * (item.amount_per_unit * 100)) /
          (100 * divider);
        item.tax_amount = item.total_amount * 0.2;
      } else {
        item.total_amount = null;
        item.tax_amount = null;
      }

      this.refreshInvoiceTotals();
    },
    toFiniteNumber(value, fallback = 0) {
      const number = Number(value);

      return Number.isFinite(number) ? number : fallback;
    },
    getItemGrossTotal(item) {
      const totalAmount = Number(item.total_amount);

      if (!Number.isFinite(totalAmount)) {
        return null;
      }

      return totalAmount + this.toFiniteNumber(item.tax_amount);
    },
    refreshInvoiceTotals() {
      const itemTotals = {
        units: 0,
        total_amount: 0,
        tax_amount: 0,
        sum: 0,
      };

      for (const item of this.formData.items || []) {
        const totalAmount = this.toFiniteNumber(item.total_amount);
        const taxAmount = this.toFiniteNumber(item.tax_amount);

        itemTotals.units += this.toFiniteNumber(item.units);
        itemTotals.total_amount += totalAmount;
        itemTotals.tax_amount += taxAmount;
        itemTotals.sum += totalAmount + taxAmount;
      }

      this.itemTotals = itemTotals;
      this.formData.amount = itemTotals.total_amount;
      this.formData.amount_tax_included = itemTotals.sum;
    },
    formatItemPeriod(item) {
      if (!item.period_starts_on || !item.period_ends_on) {
        return "-";
      }

      return `${item.period_starts_on} - ${item.period_ends_on}`;
    },
    handleDeleteClick() {
      if (this.isLoading) {
        return false;
      }

      this.isLoading = true;

      return this.$api
        .delete(`api-super-admin/customer-invoices/${this.id}`)
        .then(() => {
          this.$toast.success("Fatura silindi");

          this.$router.replace({
            name: "admin.crm.customer-invoices.list",
          });
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    if (this.id) {
      this.$nextTick(() => {
        this.load();
      });
    }
  },
};
</script>

<style>
.money-absolute-left .formatted-text {
  left: 0;
}
</style>
